import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AutoComplete, Button, Dropdown, MdSpace, NumberField, RadioButton, Section, TextField } from 'm2m.components';
import { RootState } from 'store';
import {
  updateField,
  updateCadastroMovimentacao,
  resetCadastroMovimentacao,
} from 'store/modules/novoCadastroMovimentacao/cadastroMovimentacao';
import {
  BancoResponse,
  Comprovante,
  EmissaoStatus,
  FuncaoParticipante,
  InstrumentoFinanceiro,
  InstrumentoFinanceiroApiResponse,
  InvestidorResponse,
  InvestidorResumo,
  OperacaoCompraVendaRequest,
  ParticipanteResponse,
  PosicaoResponse,
  RegistroStatus,
  TipoLiquidacao
} from 'common/genericTypes';
import { Grid, Box, Typography, Divider, Paper } from '@material-ui/core';
import ParticipanteAutoComplete from 'components/participante/participanteAutoComplete';
import { AttachFile } from '@material-ui/icons';
import { v4 as uuid } from 'uuid';
import { Download } from 'mdi-material-ui';
import { Attachment, defaultAcceptableFileTypes } from 'components/uploadDocs';
import AdicionarInvestidor, { InvestidorMovimentacaoData } from '../ofertaPrimaria/adicionarInvestidor';
import { FileService } from 'services/fileService';
import _ from 'lodash';
import { addAlert } from 'store/modules/snackBar';
import { useLocation, useHistory } from 'react-router-dom';
import InstrumentoAutocomplete from 'components/operacoes/instrumentoAutocomplete';
import { addCpfCnpjMask } from 'utils/mask';
import OperacaoParser from 'utils/parsers/operacaoParser';
import { formatNumber } from 'utils/number';
import { initialEmissor } from 'pages/cra/detalhes/initialCra';
import { ContaDepositoMask } from 'components/masks';
import { validaContaDeposito, validaCpfCnpj, stripCpfCnpjFormatting } from 'utils/validation';
import { sanitizeAlphanumericCnpj } from 'utils/cnpjUtils';
import { DelimitacaoCoordenadorResponse } from 'common/genericTypes';
import { DatePickerBusinessDay } from 'components/DatePickerBussinessDay';
import moment from 'moment';

const NovoCadastroMovimentacao: React.FC = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  const cadastroMovimentacao = useSelector((state: RootState) => state.cadastroMovimentacao.cadastroMovimentacao);
  const usuarioLogado = useSelector((state: RootState) => state.auth.usuario);
  const ofertaPrimaria = useSelector((state: RootState) => state.operacao.ofertaPrimaria);
  const getPosicoes = useSelector((state: RootState) => state.investidorApi.getPosicoes);
  const postOperacaoCompraVenda = useSelector((state: RootState) => state.operacaoApi.postOperacaoCompraVenda);
  const getInstrumentosOfertaPrimariaResume = useSelector(
    (state: RootState) => state.instrumentoApi.getInstrumentosOfertaPrimariaResume
  );
  const getInvestidoresApi = useSelector((state: RootState) => state.investidorApi.getInvestidores);
  const getInstrumentosApi = useSelector((state: RootState) => state.instrumentoApi.getInstrumentos);
  const getParticipantesResume = useSelector((state: RootState) => state.participanteApi.getParticipantesResume);
  const getBancosApi = useSelector((state: RootState) => state.catalogoApi.getBancos);
  const { postComprovanteInvestidorById, postOperacaoOfertaPrimariaCriarELiquidar } = useSelector(
    (state: RootState) => state.operacaoApi
  );
  const getQuantidadeDelimitadaPorCoordenador = useSelector(
    (state: RootState) => state.coordenadoresApi.coordenadores.getQuantidadeDelimitadaPorCoordenador
  );

  const [participantes, setParticipantes] = useState<Array<ParticipanteResponse>>([]);
  
  const [custodiantes, setCustodiantes] = useState<Array<ParticipanteResponse>>([]);
  const [emissor, setEmissor] = useState<ParticipanteResponse | null>(null);
  const [instrumentos, setInstrumentos] = useState<Array<InstrumentoFinanceiroApiResponse>>([]);
  const [instrumento, setInstrumento] = useState<InstrumentoFinanceiroApiResponse | null>(null);
  const [bancos, setBancos] = useState<Array<BancoResponse>>([]);
  const [highlight, setHightlight] = useState<boolean>(false);
  const [headers, setHeaders] = useState<string[]>([]);
  const [attachments, setAttachments] = useState<Array<Attachment>>([]);
  const [anexosInvestidores, setAnexosInvestidores] = useState<Array<Comprovante>>([]);
  const [formattedData, setFormattedData] = useState<Array<InvestidorMovimentacaoData>>([]);
  const [investidoresParteOptions, setInvestidoresParteOptions] = useState<Array<InvestidorResumo>>([]);
  const [investidoresCustodianteOptions, setInvestidoresCustodianteOptions] = useState<Array<InvestidorResponse>>([]);
  const [submitting, setSubmitting] = useState<boolean>(false);
  const [posicoes, setPosicoes] = useState<Array<PosicaoResponse>>();
  const [quantidade, setQuantidade] = useState<number>();
  const [quantidadeMax, setQuantidadeMax] = useState<number>();
  const inputRef = useRef<HTMLInputElement>(null);
  const [precoUnitario, setPrecoUnitario] = useState<number>();
  const [precoUnitarioTouched, setPrecoUnitarioTouched] = useState(false);
  const [investidorContraparteError, setInvestidorContraparteError] = useState<string>('');
  const [investidorParteError, setInvestidorParteError] = useState<string>('');
  const [instrumentoCodigo, setInstrumentoCodigo] = useState<string>('');
  const [delimitacaoCoordenador, setDelimitacaoCoordenador] = useState<Array<DelimitacaoCoordenadorResponse>>([]);
  const [delimitacaoErrorMessage, setDelimitacaoErrorMessage] = useState<string>('');
  const [exceedsDelimitacao, setExceedsDelimitacao] = useState<boolean>(false);
  const [exceedsValorDelimitacao, setExceedsValorDelimitacao] = useState<boolean>(false);
  const [quantidadeDelimitacaoObj, setQuantidadeDelimitacaoObj] = useState<DelimitacaoCoordenadorResponse | null>(null);
  const [valorDelimitacaoObj, setValorDelimitacaoObj] = useState<DelimitacaoCoordenadorResponse | null>(null);

  const [isLoadingParticipantes, setIsLoadingParticipantes] = useState<boolean>(true);
  const [isLoadingCustodiantes, setIsLoadingCustodiantes] = useState<boolean>(true);
  const [isLoadingBancos, setIsLoadingBancos] = useState<boolean>(true);
  const [isLoadingInstrumentos, setIsLoadingInstrumentos] = useState<boolean>(false);
  const [isLoadingInvestidores, setIsLoadingInvestidores] = useState<boolean>(false);
  const [isLoadingPosicoes, setIsLoadingPosicoes] = useState<boolean>(false);

  const custodianteLogadoId = usuarioLogado?.participante?.id;

  const acceptedFileTypes = defaultAcceptableFileTypes;

  const templateHeaders = ['CPF CNPJ', 'Quantidade', 'PU'];

  const headerMap: { [key: string]: string } = {
    'CPF CNPJ': 'cpfCnpj',
    Quantidade: 'quantidade',
    PU: 'pu',
  };

  useEffect(() => {
    const path = location.pathname;
    let tipoMovimentacao: 'OFERTA_PRIMARIA' | 'COMPRA' | 'VENDA' = 'OFERTA_PRIMARIA';

    if (path.includes('oferta-primaria')) {
      tipoMovimentacao = 'OFERTA_PRIMARIA';
    } else if (path.includes('/compra/')) {
      tipoMovimentacao = 'COMPRA';
    } else if (path.includes('/venda/')) {
      tipoMovimentacao = 'VENDA';
    } else if (path.includes('compra-venda')) {
      tipoMovimentacao = 'VENDA';
    }

    if (cadastroMovimentacao.tipoMovimentacao !== tipoMovimentacao) {
      dispatch(
        updateCadastroMovimentacao({
          ...cadastroMovimentacao,
          tipoMovimentacao,
        })
      );
    }
  }, []);

  const updatePrecoUnitario = (value: number | undefined) => {
    setPrecoUnitario(value);
    setPrecoUnitarioTouched(true);
  };

  const getInstrumentoList = useCallback(() => {
    let isMounted = true;
    setIsLoadingInstrumentos(true);

    getInstrumentosOfertaPrimariaResume(
      dispatch,
      {
        registroStatus: [RegistroStatus.Aprovado],
        isDetalheMovimentacaoIPO: true,
        emissorId: emissor?.id,
        tipoInstrumento: [cadastroMovimentacao.tipoAtivo],
      },
      true
    )
      .then((result) => {
        if (isMounted) {
          setInstrumentos(result);
        }
      })
      .catch(() => {
        if (isMounted) {
          dispatch(addAlert({ severity: 'error', message: 'Erro ao carregar instrumentos financeiros' }));
        }
      })
      .finally(() => {
        if (isMounted) {
          setIsLoadingInstrumentos(false);
        }
      });

    return () => {
      isMounted = false;
    };
  }, [dispatch, getInstrumentosOfertaPrimariaResume, emissor, cadastroMovimentacao.tipoAtivo]);

  const getInstrumentosCompraVenda = useCallback(() => {
    let isMounted = true;
    setIsLoadingInstrumentos(true);

    const filter = {
      registroStatus: [RegistroStatus.Aprovado],
      emissaoStatus: [EmissaoStatus.Emitido, EmissaoStatus.ParcialmenteEmitido],
      tipoInstrumento: [cadastroMovimentacao.tipoAtivo],
      emissorId: emissor?.id,
      isDetalheMovimentacaoIPO: cadastroMovimentacao.tipoMovimentacao === 'COMPRA',
    };

    getInstrumentosApi(dispatch, filter, true)
      .then((result) => {
        if (isMounted) {
          setInstrumentos(result);
        }
      })
      .catch(() => {
        if (isMounted) {
          dispatch(addAlert({ severity: 'error', message: 'Erro ao carregar instrumentos financeiros' }));
        }
      })
      .finally(() => {
        if (isMounted) {
          setIsLoadingInstrumentos(false);
        }
      });
    return () => {
      isMounted = false;
    };
  }, [dispatch, getInstrumentosApi, cadastroMovimentacao.tipoAtivo, cadastroMovimentacao.tipoMovimentacao, emissor]);

  const getParticipantes = useCallback(async () => {
    try {
      setIsLoadingParticipantes(true);
      const result = await getParticipantesResume(dispatch, {
        funcoes: [FuncaoParticipante.Emissor],
        status: RegistroStatus.Aprovado,
        suspenso: false,
      });
      setParticipantes(result);
    } catch (error) {
      dispatch(addAlert({ severity: 'error', message: 'Erro ao carregar emissores' }));
    } finally {
      setIsLoadingParticipantes(false);
    }
  }, [dispatch]);

  const getInstrumentoPorCodigo = useCallback(async () => {
    if (!!!instrumentoCodigo) {
      dispatch(updateField({ name: 'codigoInstrumento', value: instrumentoCodigo }));
      dispatch(updateField({ name: 'instrumentoId', value: '' }));
      dispatch(updateField({ name: 'instrumentoPU', value: 0 }));
      setInstrumento(null);
      setDelimitacaoCoordenador([]);
      setDelimitacaoErrorMessage('');
      return null;
    }
    try {
      if (cadastroMovimentacao.tipoMovimentacao === 'OFERTA_PRIMARIA') {
        const result = await getInstrumentosOfertaPrimariaResume(
          dispatch,
          {
            registroStatus: [RegistroStatus.Aprovado],
            isDetalheMovimentacaoIPO: true,
            codigo: instrumentoCodigo,
          },
          false
        );

        if (!result.length) {
          dispatch(
            addAlert({ severity: 'error', message: `Instrumento financeiro ${instrumentoCodigo} não encontrado` })
          );
          setDelimitacaoCoordenador([]);
          return null;
        }

        setInstrumento(result[0]);

        const tipoInstrumento = result[0].tipoInstrumentoFinanceiro;
        dispatch(updateField({ name: 'tipoAtivo', value: tipoInstrumento }));
        dispatch(updateField({ name: 'codigoInstrumento', value: instrumentoCodigo }));
        dispatch(updateField({ name: 'instrumentoId', value: result[0].instrumentoFinanceiroGuid }));
        dispatch(
          updateField({ name: 'instrumentoPU', value: result[0].criteriosRemuneracao ? result[0].criteriosRemuneracao.valorNominalUnitarioEmissao : 0 })
        );
        

        if (result[0].distribuicaoPublica && result[0].instrumentoFinanceiroGuid) {
          getQuantidadeDelimitadaCoordenador(result[0].instrumentoFinanceiroGuid);
        } else {
          setDelimitacaoCoordenador([]);
        }
        return result[0];
      } else {
        const result = await getInstrumentosApi(
          dispatch,
          {
            registroStatus: [RegistroStatus.Aprovado],
            emissaoStatus: [EmissaoStatus.Emitido, EmissaoStatus.ParcialmenteEmitido],
            instrumentosFinanceirosFilter: [
              {
                columnType: 'CODIGO',
                operationFilterType: 'CONTAINS',
                value: instrumentoCodigo,
              },
            ],
            codigo: instrumentoCodigo,
            isDetalheMovimentacaoIPO: cadastroMovimentacao.tipoMovimentacao === 'COMPRA',
          },
          true
        );

        if (!result.length) {
          dispatch(
            addAlert({ severity: 'error', message: `Instrumento financeiro ${instrumentoCodigo} não encontrado` })
          );
          setDelimitacaoCoordenador([]);
          return null;
        }

        const tipoInstrumento = result[0].tipoInstrumentoFinanceiro;

        setInstrumento(result[0]);
        dispatch(updateField({ name: 'codigoInstrumento', value: instrumentoCodigo }));
        dispatch(updateField({ name: 'instrumentoId', value: result[0].instrumentoFinanceiroGuid }));
        dispatch(updateField({ name: 'tipoAtivo', value: tipoInstrumento }));
        dispatch(
          updateField({ name: 'instrumentoPU', value: result[0].criteriosRemuneracao ? result[0].criteriosRemuneracao.valorNominalUnitarioEmissao : 0 })
        );

        return result[0];
      }
    } catch (error) {
      dispatch(addAlert({ severity: 'error', message: `Instrumento financeiro ${instrumentoCodigo} não encontrado` }));
      setDelimitacaoCoordenador([]);
      return null;
    }
  }, [dispatch, instrumentoCodigo, getQuantidadeDelimitadaPorCoordenador, cadastroMovimentacao.tipoMovimentacao]);

  const getCustodiantes = useCallback(async () => {
    try {
      setIsLoadingCustodiantes(true);
      const result = await getParticipantesResume(dispatch, {
        funcoes: [FuncaoParticipante.Custodiante],
        status: RegistroStatus.Aprovado,
        suspenso: false,
      });

      setCustodiantes(result);
    } catch (error) {
      dispatch(addAlert({ severity: 'error', message: 'Erro ao carregar custodiantes' }));
    } finally {
      setIsLoadingCustodiantes(false);
    }
  }, [dispatch]);

  const getBancos = useCallback(async () => {
    try {
      setIsLoadingBancos(true);
      const result = await getBancosApi(dispatch, false);
      setBancos(typeof result === 'string' ? [] : result.banks);
    } catch (error) {
      dispatch(addAlert({ severity: 'error', message: 'Erro ao carregar bancos' }));
    } finally {
      setIsLoadingBancos(false);
    }
  }, [dispatch]);

  useEffect(() => {
    getParticipantes();
    getCustodiantes();
    getBancos();
  }, [getParticipantes, getCustodiantes, getBancos]);

  useEffect(() => {
    if (custodiantes.length > 0 && custodianteLogadoId && !cadastroMovimentacao.parte.participante) {
      const custodianteLogado = custodiantes.find((p) => p.id === custodianteLogadoId);
      if (custodianteLogado) {
        dispatch(
          updateCadastroMovimentacao({
            ...cadastroMovimentacao,
            parte: {
              contaDeposito: null,
              investidor: null,
              participante: custodianteLogado,
              dadosBancarios: null,
            },
          })
        );
      }
    }
  }, [custodiantes, custodianteLogadoId, dispatch, cadastroMovimentacao]);

  useEffect(() => {
    if (!custodianteLogadoId) return;

    let cancelado = false;
    setIsLoadingInvestidores(true);

    getInvestidoresApi(dispatch, { participanteId: custodianteLogadoId }, true)
      .then((result) => {
        if (!cancelado) setInvestidoresCustodianteOptions(result);
      })
      .catch(() => {
        if (!cancelado) dispatch(addAlert({ severity: 'error', message: 'Erro ao carregar investidores' }));
      })
      .finally(() => {
        if (!cancelado) setIsLoadingInvestidores(false);
      });

    return () => {
      cancelado = true;
    };
  }, [custodianteLogadoId, dispatch, getInvestidoresApi]);

  useEffect(() => {
    if (!emissor) return;

    let cleanup: (() => void) | undefined;

    if (cadastroMovimentacao.tipoMovimentacao === 'OFERTA_PRIMARIA') {
      cleanup = getInstrumentoList();
    } else if (
      cadastroMovimentacao.tipoMovimentacao === 'COMPRA' ||
      cadastroMovimentacao.tipoMovimentacao === 'VENDA'
    ) {
      cleanup = getInstrumentosCompraVenda();
    }

    return () => {
      if (cleanup) cleanup();
    };
  }, [
    emissor,
    cadastroMovimentacao.tipoMovimentacao,
    cadastroMovimentacao.tipoAtivo,
    getInstrumentoList,
    getInstrumentosCompraVenda,
  ]);

  const instrumentosFinanceirosOptions = Object.values(InstrumentoFinanceiro).map((i: InstrumentoFinanceiro) => ({
    value: i,
    description: i.replaceAll('_', ' '),
  }));

  const bancosFilter = (value: string) =>
    bancos.filter(
      (b) =>
        b.code.includes(value) ||
        b.fullname.toLocaleLowerCase().includes(value) ||
        b.ispb.includes(value) ||
        b.shortname.toLocaleLowerCase().includes(value)
    );

  const handleInstrumentoSelect = (value: InstrumentoFinanceiroApiResponse | null) => {
    if (value) {
      setInstrumento(value);
      const tipoInstrumento = value.tipoInstrumentoFinanceiro;

      dispatch(updateField({ name: 'tipoAtivo', value: tipoInstrumento }));
      dispatch(updateField({ name: 'codigoInstrumento', value: value.codigo }));
      dispatch(updateField({ name: 'instrumentoId', value: value.instrumentoFinanceiroGuid }));
      dispatch(updateField({ name: 'instrumentoPU', value: value.criteriosRemuneracao ? value.criteriosRemuneracao.valorNominalUnitarioEmissao : 0 }));

      if (cadastroMovimentacao.tipoMovimentacao !== 'OFERTA_PRIMARIA')
        getInvestidoresPosicoes(value.instrumentoFinanceiroGuid);

      const instrumentoGuid = value.instrumentoFinanceiroGuid;

      setDelimitacaoErrorMessage('');

      if (instrumentoGuid && value.distribuicaoPublica) {
        getQuantidadeDelimitadaCoordenador(instrumentoGuid);
      } else {
        setDelimitacaoCoordenador([]);
      }
    }
  };

  const getQuantidadeDelimitadaCoordenador = (instrumentoGuid: string) => {
    setDelimitacaoErrorMessage('');
    const mensagemErro =
      'Este instrumento não está elegível para oferta primária porque a delimitação ainda não foi concluída.';
    getQuantidadeDelimitadaPorCoordenador(dispatch, instrumentoGuid)
      .then((response) => {
        if (!response || response.length === 0) {
          if (cadastroMovimentacao.tipoMovimentacao === 'OFERTA_PRIMARIA') {
            setDelimitacaoErrorMessage(
              'Este instrumento não está elegível para oferta primária porque não há coordenadores com delimitação.'
            );
          }
          setDelimitacaoCoordenador([]);
          return;
        }

        const hasValidDelimitation = response.some(
          (item) => item.valor !== undefined && item.valor !== null && item.valor > 0
        );

        if (!hasValidDelimitation && cadastroMovimentacao.tipoMovimentacao === 'OFERTA_PRIMARIA') {
          setDelimitacaoErrorMessage(mensagemErro);
        }

        setDelimitacaoCoordenador(response);
      })
      .catch((error: any) => {
        setDelimitacaoCoordenador([]);

        if (
          error.response &&
          error.response.status === 400 &&
          cadastroMovimentacao.tipoMovimentacao === 'OFERTA_PRIMARIA'
        ) {
          setDelimitacaoErrorMessage(mensagemErro);
        } else {
          let errorMessage = 'Erro ao buscar delimitação por coordenador.';

          if (error.response && error.response.data) {
            if (typeof error.response.data === 'string') {
              errorMessage = error.response.data;
            } else if (error.response.data.message) {
              errorMessage = error.response.data.message;
            } else if (error.response.data.error) {
              errorMessage = error.response.data.error;
            }
          } else if (error.message) {
            errorMessage = error.message;
          }

          setDelimitacaoErrorMessage(errorMessage);
        }
      });
  };

  const isValidFileType = (files: File[]): boolean => {
    return acceptedFileTypes.some((type) => files.some((file) => file?.type === type));
  };

  const handleFileTypeError = () => {
    setHightlight(false);
  };

  const openFileDialog = () => {
    inputRef?.current?.click();
  };

  const onDrop = async (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault();
    setAttachments([]);
    let newFiles: File[] = [];

    if (event.dataTransfer.files) {
      newFiles[0] = event.dataTransfer.files[0];
    }

    if (!newFiles.length) return;

    if (!isValidFileType(newFiles)) {
      handleFileTypeError();
      return;
    }

    const newAttachments = newFiles.map((newFile) => {
      return {
        id: uuid(),
        file: newFile,
      };
    });
    setAttachments(newAttachments);
    setHightlight(false);

    if (newFiles[0]) {
      try {
        await parseAndValidateFile(newFiles[0]);
      } catch (error) {
        const errorMessage = error instanceof Error ? error.message : 'Erro ao processar arquivo';
        dispatch(addAlert({ severity: 'error', message: errorMessage }));
      }
    }
  };

  const onDragOver = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault();
    setHightlight(true);
  };

  const onDragLeave = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault();
    setHightlight(false);
  };

  const onInputChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    event.preventDefault();

    setAttachments([]);
    let newFiles: File[] = [];
    if (event.target.files) {
      newFiles[0] = event.target.files?.[0];
    }

    if (!newFiles.length) return;

    if (!isValidFileType(newFiles)) {
      handleFileTypeError();
      return;
    }

    const newAttachments = newFiles.map((newFile) => {
      return {
        id: uuid(),
        file: newFile,
      };
    });

    let updatedAttachments: Attachment[];
    if (attachments.some(({ id }) => id === uuid())) {
      updatedAttachments = attachments.filter((file) => file.id !== uuid()).concat(newAttachments);
    } else {
      updatedAttachments = attachments.concat(newAttachments);
    }

    setHightlight(false);
    setAttachments(newAttachments);

    if (newFiles[0]) {
      try {
        await parseAndValidateFile(newFiles[0]);
      } catch (error) {
        const errorMessage = error instanceof Error ? error.message : 'Erro ao processar arquivo';
        dispatch(addAlert({ severity: 'error', message: errorMessage }));
      }
    }
  };

  const parseAndValidateFile = async (file: File) => {
    try {
      const parsedData = await FileService.parseFile(file, templateHeaders);

      setHeaders(parsedData.headers);

      const investidores: InvestidorMovimentacaoData[] = parsedData.rows.map((row) => {
        const investidor: any = {
          id: uuid(),
        };

        headers.forEach((header, headerIndex) => {
          const fieldName = headerMap[header] ?? _.camelCase(header);
          const cellValue = row[headerIndex];
          investidor[fieldName] = cellValue !== null && cellValue !== undefined ? String(cellValue) : '';
        });

        const errors: string[] = [];

        headers.forEach((header) => {
          const fieldName = headerMap[header] ?? _.camelCase(header);
          if (!investidor[fieldName]) {
            errors.push(`${header} é obrigatório`);
          }
        });

        investidor.valido = errors.length === 0;
        investidor.mensagemErro = errors.join(', ');

        return investidor as InvestidorMovimentacaoData;
      });

      setFormattedData(investidores);
    } catch (error) {
      throw error;
    }
  };

  const filterInvestidores = (options: Array<InvestidorResponse>, value: string) => {
    var valueUpperCase = value.toUpperCase();
    return options.filter(
      (op) =>
        op?.razaoSocial?.toLocaleUpperCase().includes(valueUpperCase) ||
        op?.cpfCnpj?.toLocaleUpperCase().includes(valueUpperCase)
    );
  };

  const getInvestidoresPosicoes = useCallback(
    (instrumentoFinanceiroId?: string) => {
      let isMounted = true;
      setIsLoadingPosicoes(true);

      getPosicoes(dispatch, instrumentoFinanceiroId ? { instrumentoFinanceiroId } : undefined, true)
        .then((result: Array<PosicaoResponse>) => {
          if (isMounted) {
            setInvestidoresParteOptions(result.map((posicao) => posicao.investidor));
            setPosicoes(result);
          }
        })
        .catch(() => {
          if (isMounted) {
            dispatch(addAlert({ severity: 'error', message: 'Erro ao carregar posições dos investidores' }));
          }
        })
        .finally(() => {
          if (isMounted) {
            setIsLoadingPosicoes(false);
          }
        });

      return () => {
        isMounted = false;
      };
    },
    [dispatch, getPosicoes]
  );

  const resetState = () => {
    dispatch(resetCadastroMovimentacao());
    setQuantidade(undefined);
    setPrecoUnitario(undefined);
    setPrecoUnitarioTouched(false);
    setInstrumento(null);
    setEmissor(null);
    setAttachments([]);
    setAnexosInvestidores([]);
    setFormattedData([]);
    setDelimitacaoErrorMessage('');
    setExceedsDelimitacao(false);
    setExceedsValorDelimitacao(false);
    setQuantidadeDelimitacaoObj(null);
    setValorDelimitacaoObj(null);
    setDelimitacaoCoordenador([]);
    setInstrumentoCodigo('');
  };

  useEffect(() => {
    let cleanup: (() => void) | undefined;
    if (instrumento) {
      cleanup = getInvestidoresPosicoes(instrumento.instrumentoFinanceiroGuid);
    }
    return () => {
      if (cleanup) cleanup();
    };
  }, [instrumento, getInvestidoresPosicoes]);

  useEffect(() => {
    if (delimitacaoCoordenador && delimitacaoCoordenador.length > 0) {
      const quantidadeDelimitacao = delimitacaoCoordenador
        .filter((d) => d.tipoDelimitacao === 'QUANTIDADE')
        .sort((a, b) => (a.isCoordenadorLider === b.isCoordenadorLider ? 0 : a.isCoordenadorLider ? -1 : 1))[0];

      if (quantidadeDelimitacao) {
        setQuantidadeDelimitacaoObj(quantidadeDelimitacao);
      } else {
        setQuantidadeDelimitacaoObj(null);
      }

      const valorDelimitacao = delimitacaoCoordenador
        .filter((d) => d.tipoDelimitacao === 'VALOR')
        .sort((a, b) => (a.isCoordenadorLider === b.isCoordenadorLider ? 0 : a.isCoordenadorLider ? -1 : 1))[0];

      if (valorDelimitacao) {
        setValorDelimitacaoObj(valorDelimitacao);
      } else {
        setValorDelimitacaoObj(null);
      }
    } else {
      setQuantidadeDelimitacaoObj(null);
      setValorDelimitacaoObj(null);
    }
  }, [delimitacaoCoordenador]);

  useEffect(() => {
    let exceeds = false;

    const investidores = ofertaPrimaria?.investidores ?? [];

    if (investidores.length > 0 && quantidadeDelimitacaoObj) {
      const totalQuantidade = investidores.reduce((sum, investidor) => {
        const quantidade = Number(investidor.quantidade || 0);
        return sum + (isNaN(quantidade) ? 0 : quantidade);
      }, 0);

      exceeds = totalQuantidade > Number(quantidadeDelimitacaoObj.valor);
    }

    setExceedsDelimitacao(exceeds);
  }, [ofertaPrimaria, quantidadeDelimitacaoObj]);

  useEffect(() => {
    let exceedsValor = false;

    const investidores = ofertaPrimaria?.investidores ?? [];

    if (investidores.length > 0 && valorDelimitacaoObj) {
      const totalValor = investidores.reduce((sum, investidor) => {
        const quantidade = Number(investidor.quantidade || 0);
        const pu = Number(investidor.precoUnitario || cadastroMovimentacao.instrumentoPU || 0);
        const investidorValor = quantidade * pu;
        return sum + (isNaN(investidorValor) ? 0 : investidorValor);
      }, 0);

      exceedsValor = totalValor > Number(valorDelimitacaoObj.valor);
    }

    setExceedsValorDelimitacao(exceedsValor);
  }, [ofertaPrimaria, valorDelimitacaoObj, cadastroMovimentacao.instrumentoPU]);

  const isOfertaPrimariaValid = useCallback(() => {
    const { instrumentoId, instrumentoPU } = cadastroMovimentacao;
    const investidores = ofertaPrimaria?.investidores ?? [];

    if (exceedsDelimitacao || exceedsValorDelimitacao) {
      return false;
    }

    const instrumentoPUValid = cadastroMovimentacao.tipoAtivo === InstrumentoFinanceiro.CotasDeFundo || instrumentoPU > 0;
    
    return !!instrumentoId && instrumentoPUValid && investidores.length > 0;
  }, [cadastroMovimentacao, ofertaPrimaria, exceedsDelimitacao, exceedsValorDelimitacao]);

  const isCompraVendaValid = useCallback(() => {
    const { instrumentoId, instrumentoPU, contraparte, parte, bancoPagador, tipoMovimentacao } =
      cadastroMovimentacao;

    if (!instrumentoId || instrumentoPU <= 0) {
      return false;
    }

    if (!quantidade || quantidade <= 0) {
      return false;
    }

    if (!precoUnitario || precoUnitario <= 0) {
      return false;
    }

    if (tipoMovimentacao === 'COMPRA') {
      return !!parte.participante && !!contraparte.contaDeposito && !!bancoPagador?.ispb && !!parte.investidor;
    } else if (tipoMovimentacao === 'VENDA') {
      if (quantidade > (quantidadeMax ?? 0)) {
        return false;
      }

      return !!parte.participante && !!contraparte.contaDeposito && !!contraparte.participante && !!bancoPagador?.ispb;
    }
    return false;
  }, [cadastroMovimentacao, quantidade, quantidadeMax, precoUnitario]);

  const isFormValid = useCallback(() => {
    if (cadastroMovimentacao.tipoMovimentacao === 'OFERTA_PRIMARIA') {
      return isOfertaPrimariaValid();
    } else if (
      cadastroMovimentacao.tipoMovimentacao === 'COMPRA' ||
      cadastroMovimentacao.tipoMovimentacao === 'VENDA'
    ) {
      return isCompraVendaValid();
    }
    return false;
  }, [cadastroMovimentacao.tipoMovimentacao, isOfertaPrimariaValid, isCompraVendaValid]);

  const handleMovimentacaoSubmit = useCallback(() => {
    if (!isFormValid()) {
      return;
    }

    let isMounted = true;
    setSubmitting(true);

    const submitForm = async () => {
      try {
        if (cadastroMovimentacao.tipoMovimentacao === 'OFERTA_PRIMARIA') {
          if (!cadastroMovimentacao.instrumentoId) {
            if (isMounted) {
              dispatch(
                addAlert({ severity: 'error', message: 'Ocorreu um erro inesperado, favor refazer o formulário' })
              );
            }
            return;
          }

          const investidores = ofertaPrimaria?.investidores ?? [];

          if (investidores.length === 0) {
            if (isMounted) {
              dispatch(addAlert({ severity: 'error', message: 'É necessário adicionar pelo menos um investidor' }));
            }
            return;
          }

          const isLiquidacaoDireta = cadastroMovimentacao.modalidadeLiquidacao === 'DIRETA';
          const tipoLiquidacao = isLiquidacaoDireta ? 'Direta' : 'Outras';
          let puEmissao = cadastroMovimentacao.instrumentoPU;
          
          if (cadastroMovimentacao.tipoAtivo === InstrumentoFinanceiro.CotasDeFundo && cadastroMovimentacao.instrumentoPU === 0) {
            const precosValidos = investidores
              .map((investidor) => investidor.precoUnitario)
              .filter((preco) => preco != null && preco > 0);
            
            puEmissao = precosValidos.length > 0 ? Math.min(...precosValidos) : 0;
          }

          const request = OperacaoParser.stateToOperacaoOfertaPrimariaRaCriar_LiquidarRequest(
            {
              ofertaPrimaria: {
                investidores: investidores,
                informacoesBancarias: [
                  {
                    razaoSocialBanco: cadastroMovimentacao.bancoPagador?.fullname ?? '',
                    agenciaBanco: cadastroMovimentacao.parte.dadosBancarios?.agencia ?? '',
                    contaBanco: cadastroMovimentacao.parte.dadosBancarios?.conta ?? '',
                    ispbBanco: cadastroMovimentacao.bancoPagador?.code ?? '',
                  },
                ],
              },
              instrumentoFinanceiroId: cadastroMovimentacao.instrumentoId,
              tipoInstrumentoFinanceiro: cadastroMovimentacao.tipoAtivo,
              dataAgendamento: cadastroMovimentacao.dataAgendamento?.toDate(),
              criteriosRemuneracao: {
                valorNominalUnitarioEmissao: puEmissao,
              },
            },
            tipoLiquidacao === 'Direta' ? TipoLiquidacao.Direta : TipoLiquidacao.Outras
          );

          try {
            const ofertaPrimaria = await postOperacaoOfertaPrimariaCriarELiquidar(dispatch, request, true);

            if (anexosInvestidores?.length > 0) {
              const comprovantesPorInvestidor = anexosInvestidores.reduce((acc, comprovante) => {
                if (!acc[comprovante.investidorId]) {
                  acc[comprovante.investidorId] = [];
                }
                if (comprovante.file) {
                  acc[comprovante.investidorId].push(comprovante.file);
                }
                return acc;
              }, {} as Record<string, File[]>);

              await Promise.all(
                Object.entries(comprovantesPorInvestidor).map(([investidorId, files]) =>
                  postComprovanteInvestidorById(dispatch, ofertaPrimaria.id, investidorId, files, true)
                )
              );
            }

            if (isMounted) {
              dispatch(addAlert({ severity: 'success', message: 'Oferta primária cadastrada com sucesso!' }));
              history.push('/operacoes/gerenciar');
            }
          } catch (error: any) {
            if (isMounted) {
              let errorMessage = 'Erro ao enviar os dados da operação.';

              if (error.response && error.response.status === 400 && error.response.data) {
                if (typeof error.response.data === 'string') {
                  errorMessage = error.response.data;
                }
              }

              dispatch(addAlert({ severity: 'error', message: errorMessage }));
            }
          }
        } else if (
          cadastroMovimentacao.tipoMovimentacao === 'COMPRA' ||
          cadastroMovimentacao.tipoMovimentacao === 'VENDA'
        ) {
          if (!cadastroMovimentacao.instrumentoId) {
            if (isMounted) {
              dispatch(
                addAlert({ severity: 'error', message: 'Ocorreu um erro inesperado, favor refazer o formulário' })
              );
            }
            return;
          }

          const { parte, contraparte, instrumentoPU } = cadastroMovimentacao;
          const isCompra = cadastroMovimentacao.tipoMovimentacao === 'COMPRA';
          const liquidacaoDireta = cadastroMovimentacao.modalidadeLiquidacao === 'DIRETA';
          let operacaoRequest = {};

          if (isCompra) {
            const dadosInvestidorOrigem = stripCpfCnpjFormatting(contraparte.contaDeposito || '');
            const isCpfCnpjInvestidorOrigem =
              dadosInvestidorOrigem?.length === 11 || dadosInvestidorOrigem?.length === 14;

            operacaoRequest = {
              quantidade: quantidade || 1,
              precoUnitario: precoUnitario || instrumentoPU,
              liquidacaoDireta,
              origem: {
                custodianteCnpj: contraparte.participante?.cnpj.replace(/\D+/g, '') || '',
                cpfCnpjInvestidor: isCpfCnpjInvestidorOrigem ? dadosInvestidorOrigem : '',
                contaDepositoOrigem: isCpfCnpjInvestidorOrigem ? '' : contraparte.contaDeposito,
              },
              destino: {
                custodianteCnpj: parte.participante?.cnpj.replace(/\D+/g, '') || '',
                contaDepositoDestino: parte.investidor?.contaDeposito || '',
                cpfCnpjInvestidorDestino: parte.investidor?.cpfCnpj || '',
              },
            };
          } else {
            const dadosInvestidorDestino = stripCpfCnpjFormatting(contraparte.contaDeposito || '');
            const isCpfCnpjInvestidorDestino =
              dadosInvestidorDestino?.length === 11 || dadosInvestidorDestino?.length === 14;

            operacaoRequest = {
              quantidade: quantidade || 1,
              precoUnitario: precoUnitario || instrumentoPU,
              liquidacaoDireta,
              origem: {
                custodianteCnpj: parte.participante?.cnpj.replace(/\D+/g, '') || '',
                cpfCnpjInvestidor: parte.investidor?.cpfCnpj.replace(/\D+/g, '') || '',
                contaDepositoOrigem: parte.investidor?.contaDeposito || '',
              },
              destino: {
                custodianteCnpj: contraparte.participante?.cnpj.replace(/\D+/g, '') || '',
                contaDepositoDestino: isCpfCnpjInvestidorDestino ? '' : contraparte.contaDeposito,
                cpfCnpjInvestidorDestino: isCpfCnpjInvestidorDestino
                  ? dadosInvestidorDestino
                  : contraparte.investidor?.cpfCnpj || '',
              },
            };
          }

          try {
            await postOperacaoCompraVenda(
              dispatch,
              cadastroMovimentacao.instrumentoId,
              [operacaoRequest as OperacaoCompraVendaRequest],
              true
            );

            if (isMounted) {
              resetState();

              dispatch(
                addAlert({
                  severity: 'success',
                  message: `Operação de ${isCompra ? 'compra' : 'venda'} cadastrada com sucesso!`,
                })
              );

              history.push('/operacoes/gerenciar');
            }
          } catch (error) {
            if (isMounted) {
              dispatch(addAlert({ severity: 'error', message: 'Erro ao enviar os dados da operação.' }));
            }
          }
        }
      } catch (error) {
        if (isMounted) {
          dispatch(addAlert({ severity: 'error', message: 'Ocorreu um erro ao processar a solicitação.' }));
        }
      } finally {
        if (isMounted) {
          setSubmitting(false);
        }
      }
    };

    submitForm();
  }, [
    isFormValid,
    cadastroMovimentacao,
    ofertaPrimaria,
    dispatch,
    attachments,
    anexosInvestidores,
    postOperacaoOfertaPrimariaCriarELiquidar,
    postComprovanteInvestidorById,
    quantidade,
    precoUnitario,
  ]);

  useEffect(() => {
    const maxValue =
      cadastroMovimentacao.tipoMovimentacao === 'VENDA'
        ? posicoes?.find((posicao) => posicao.investidor.id === cadastroMovimentacao.parte.investidor?.id)
          ?.saldoDisponivel
        : posicoes?.find((posicao) => posicao.investidor.id === cadastroMovimentacao.contraparte.investidor?.id)
          ?.saldoDisponivel;

    setQuantidadeMax(maxValue);
  }, [
    cadastroMovimentacao.parte.investidor?.id,
    posicoes,
    cadastroMovimentacao.contraparte.investidor?.id,
    cadastroMovimentacao.tipoMovimentacao,
  ]);

  useEffect(() => {
    if (quantidade !== undefined && quantidadeMax !== undefined && quantidade > quantidadeMax) {
      setQuantidade(quantidadeMax);
    }
  }, [quantidade, quantidadeMax]);

  const [quantidadeError, setQuantidadeError] = useState<string>('');

  useEffect(() => {
    if (cadastroMovimentacao.tipoMovimentacao === 'VENDA' && !cadastroMovimentacao.parte.investidor) {
      setQuantidadeError('Selecione um investidor');
      return;
    }

    if (cadastroMovimentacao.tipoMovimentacao === 'COMPRA' && !cadastroMovimentacao.contraparte.investidor) {
      setQuantidadeError('Selecione um investidor');
      return;
    }

    if (quantidadeMax === 0 || quantidadeMax === undefined) {
      setQuantidadeError('Investidor não possui posições para alocar');
      return;
    }

    if (quantidade !== undefined && quantidade !== null && quantidade > (quantidadeMax ?? 0)) {
      setQuantidadeError(`Valor excede a quantidade disponível: ${formatNumber(quantidadeMax ?? 0)}`);
      return;
    }

    setQuantidadeError('');
  }, [cadastroMovimentacao.parte.investidor, cadastroMovimentacao.tipoMovimentacao, quantidade, quantidadeMax]);

  const getQuantidadeHelperText = () => {
    if (quantidadeError) {
      return quantidadeError;
    }

    if (cadastroMovimentacao.tipoMovimentacao !== 'OFERTA_PRIMARIA' && quantidadeMax !== undefined) {
      return `Quantidade disponível: ${formatNumber(quantidadeMax)}`;
    }

    return '';
  };

  const parseTitle = (title: 'OFERTA_PRIMARIA' | 'COMPRA' | 'VENDA') => {
    const titles = {
      OFERTA_PRIMARIA: 'Oferta Primária',
      COMPRA: 'Compra',
      VENDA: 'Venda',
    };

    return titles[title];
  };

  const isLoading = () => {
    return (
      isLoadingParticipantes ||
      isLoadingCustodiantes ||
      isLoadingBancos ||
      isLoadingInstrumentos ||
      isLoadingInvestidores ||
      isLoadingPosicoes ||
      submitting
    );
  };

  const handleChangeTipoPesquisa = (value: 'CODIGO' | 'EMISSOR') => {
    resetState();
    dispatch(updateCadastroMovimentacao({ ...cadastroMovimentacao, tipoPesquisa: value }));
  };

  return (
    <Box p={3}>
      <div>
        <Typography variant="h1">{parseTitle(cadastroMovimentacao.tipoMovimentacao)}</Typography>
      </div>

      {/* Parte */}
      {(cadastroMovimentacao.tipoMovimentacao === 'COMPRA' || cadastroMovimentacao.tipoMovimentacao === 'VENDA') && (
        <Section title="Parte" isFulfilled={() => true} defaultGrid={false}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <AutoComplete
                label="Custodiante (Parte)"
                options={custodiantes}
                getOptionLabel={(option: ParticipanteResponse) =>
                  `${option.razaoSocial} - ${addCpfCnpjMask(option.cnpj)}`
                }
                value={cadastroMovimentacao.parte.participante}
                disabled={true}
                PaperComponent={({ children }) => <Paper style={{ width: '500px', height: '100%' }}>{children}</Paper>}
                renderOption={(option: ParticipanteResponse) => (
                  <div style={{ width: '100%' }}>
                    <div style={{ display: 'flex' }}>
                      <Typography style={{ margin: 'auto 12px' }}>{addCpfCnpjMask(option.cnpj)}</Typography>
                    </div>
                    <div>
                      <Typography style={{ margin: 'auto 12px' }} variant="body2">
                        {option.razaoSocial}
                      </Typography>
                    </div>
                  </div>
                )}
                required
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <AutoComplete
                label={'Banco *'}
                options={bancos ?? []}
                getOptionLabel={(option: BancoResponse | null) => {
                  if (!option) return '';
                  return `${option.code} - ${option.fullname}`;
                }}
                value={cadastroMovimentacao.bancoPagador || null}
                onChange={(value: BancoResponse | null) => {
                  if (value) {
                    dispatch(
                      updateCadastroMovimentacao({
                        ...cadastroMovimentacao,
                        bancoPagador: value,
                      })
                    );
                  }
                }}
                filterOptions={
                  bancos
                    ? (_options: Array<BancoResponse>, state) => bancosFilter(state.inputValue.toLocaleLowerCase())
                    : undefined
                }
              />
            </Grid>
          </Grid>
        </Section>
      )}

      <Grid container spacing={3}>
        <Grid item xs={12} md={12}>
          <Divider />
        </Grid>
      </Grid>

      {/* Movimentação */}
      <Section title="Movimentação" isFulfilled={() => true} defaultGrid={false}>
        <Box>
          <Grid container spacing={3}>
            <Grid item xs={12} md={12}>
              <RadioButton
                label="Tipo de Pesquisa do IF"
                options={[
                  { value: 'CODIGO', description: 'Código' },
                  { value: 'EMISSOR', description: 'Emissor' },
                ]}
                value={cadastroMovimentacao.tipoPesquisa ?? ''}
                onChange={(value: string) => {
                  const typed = value as 'CODIGO' | 'EMISSOR';
                  handleChangeTipoPesquisa(typed);
                }}
                inline
              />
            </Grid>

            {cadastroMovimentacao.tipoPesquisa === 'EMISSOR' && (
              <>
                <Grid item xs={12} md={6}>
                  <Dropdown
                    label="Tipo Ativo"
                    options={instrumentosFinanceirosOptions}
                    value={cadastroMovimentacao.tipoAtivo}
                    onChange={(value) => {
                      if (value !== cadastroMovimentacao.tipoAtivo) {
                        setEmissor(null);
                        setInstrumento(null);
                        dispatch(
                          updateCadastroMovimentacao({
                            ...cadastroMovimentacao,
                            tipoAtivo: value as InstrumentoFinanceiro,
                            emissor: initialEmissor,
                            codigoInstrumento: '',
                            instrumentoId: '',
                            instrumentoPU: 0,
                            parte: {
                              ...cadastroMovimentacao.parte,
                              investidor: null,
                            },
                          })
                        );
                      } else {
                        dispatch(updateField({ name: 'tipoAtivo', value }));
                      }
                    }}
                    required
                  />
                </Grid>

                <Grid item xs={12} md={6}>
                  <ParticipanteAutoComplete
                    label={`Emissor *`}
                    participantes={participantes}
                    participante={emissor}
                    onChange={(value) => {
                      const emissorChanged = value?.id !== cadastroMovimentacao.emissor?.id;

                      if (emissorChanged) {
                        setEmissor(value);
                        setInstrumento(null);

                        if (value) {
                          dispatch(
                            updateCadastroMovimentacao({
                              ...cadastroMovimentacao,
                              emissor: value as ParticipanteResponse,
                              codigoInstrumento: '',
                              instrumentoId: '',
                              instrumentoPU: 0,
                              parte: {
                                ...cadastroMovimentacao.parte,
                                investidor: null,
                              },
                            })
                          );
                        } else {
                          dispatch(
                            updateCadastroMovimentacao({
                              ...cadastroMovimentacao,
                              emissor: initialEmissor,
                              codigoInstrumento: '',
                              instrumentoId: '',
                              instrumentoPU: 0,
                              parte: {
                                ...cadastroMovimentacao.parte,
                                investidor: null,
                              },
                            })
                          );
                        }
                      } else if (value) {
                        setEmissor(value);
                        dispatch(
                          updateCadastroMovimentacao({
                            ...cadastroMovimentacao,
                            emissor: value,
                          })
                        );
                      }
                    }}
                  />
                </Grid>
              </>
            )}
          </Grid>

          <Box mt={3}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={6}>
                {cadastroMovimentacao.tipoPesquisa === 'EMISSOR' && (
                  <>
                    <InstrumentoAutocomplete
                      instrumentos={instrumentos}
                      onChange={handleInstrumentoSelect}
                      instrumento={instrumento}
                    />
                  </>
                )}
                {cadastroMovimentacao.tipoPesquisa === 'CODIGO' && (
                  <>
                    <TextField
                      label="Código do IF"
                      value={instrumentoCodigo}
                      onChange={(value) => setInstrumentoCodigo(value)}
                      onBlur={getInstrumentoPorCodigo}
                    />
                  </>
                )}
              </Grid>
            </Grid>
          </Box>

          {cadastroMovimentacao.tipoMovimentacao === 'VENDA' && (
            <>
              <Grid container spacing={3}>
                <Grid item xs={12} md={12}>
                  <AutoComplete
                    label="Investidor (Parte)"
                    options={investidoresParteOptions}
                    getOptionLabel={(option: InvestidorResumo) => {
                      if (!option) return '';
                      return `${option.razaoSocial}`;
                    }}
                    filterOptions={(options, state) => filterInvestidores(options, state.inputValue)}
                    value={cadastroMovimentacao.parte.investidor}
                    onChange={(value: InvestidorResumo | null) => {
                      const currentInvestidorId = cadastroMovimentacao.parte.investidor?.id;
                      const newInvestidorId = value?.id;
                      const investidorChanged = currentInvestidorId !== newInvestidorId;

                      if (investidorChanged) {
                        if (value) {
                          const selectedInvestidor = investidoresParteOptions.find((p) => p.id === value.id);

                          if (selectedInvestidor) {
                            if (cadastroMovimentacao.tipoMovimentacao === 'VENDA') {
                              dispatch(
                                updateCadastroMovimentacao({
                                  ...cadastroMovimentacao,
                                  parte: {
                                    ...cadastroMovimentacao.parte,
                                    investidor: selectedInvestidor,
                                  },
                                })
                              );

                              setQuantidade(0);
                              setPrecoUnitario(0);
                            }

                            setQuantidade(0);
                            setPrecoUnitario(0);
                          }
                        } else {
                          dispatch(
                            updateCadastroMovimentacao({
                              ...cadastroMovimentacao,
                              parte: {
                                ...cadastroMovimentacao.parte,
                                investidor: null,
                              },
                            })
                          );

                          setQuantidade(0);
                          setPrecoUnitario(0);
                        }
                      } else if (value) {
                        const selectedInvestidor = investidoresParteOptions.find((p) => p.id === value.id);
                        if (selectedInvestidor) {
                          dispatch(
                            updateCadastroMovimentacao({
                              ...cadastroMovimentacao,
                              parte: {
                                ...cadastroMovimentacao.parte,
                                investidor: selectedInvestidor,
                              },
                            })
                          );
                        }
                      }
                    }}
                    PaperComponent={({ children }) => (
                      <Paper style={{ width: '500px', height: '100%' }}>{children}</Paper>
                    )}
                    renderOption={(option: InvestidorResumo) => (
                      <div style={{ width: '100%' }}>
                        <Grid container>
                          <Grid item xs={4}>
                            <div>
                              <Typography style={{ margin: 'auto' }} variant="subtitle2">
                                {'CPF/CNPJ'}
                              </Typography>
                            </div>
                            <div>
                              <Typography style={{ margin: 'auto' }}>{addCpfCnpjMask(option.cpfCnpj)}</Typography>
                            </div>
                          </Grid>
                          <Grid item xs={4}>
                            <div>
                              <Typography style={{ margin: 'auto' }} variant="subtitle2">
                                {'Razão Social'}
                              </Typography>
                            </div>
                            <div>
                              <Typography style={{ margin: 'auto' }}>{option.razaoSocial}</Typography>
                            </div>
                          </Grid>
                          <Grid item xs={4}>
                            <div>
                              <Typography style={{ margin: 'auto' }} variant="subtitle2">
                                {'Conta depósito'}
                              </Typography>
                            </div>
                            <div>
                              <Typography style={{ margin: 'auto' }}>{option.contaDeposito}</Typography>
                            </div>
                          </Grid>
                        </Grid>
                      </div>
                    )}
                    required
                  />
                </Grid>
              </Grid>

              <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                  <NumberField
                    label="Quantidade"
                    value={quantidade}
                    onChange={(value) => {
                      if (value === undefined || value === null) {
                        setQuantidade(0);
                        return;
                      }

                      const numericValue = typeof value === 'string' ? parseFloat(value) : value;

                      setQuantidade(numericValue);
                    }}
                    required
                    disabled={
                      (cadastroMovimentacao.tipoMovimentacao === 'VENDA' && !cadastroMovimentacao.parte.investidor) ||
                      quantidadeMax === 0 ||
                      quantidadeMax === undefined
                    }
                    numberType="integer"
                    error={!!quantidadeError}
                    errorMessage={quantidadeError}
                    helperText={getQuantidadeHelperText()}
                  />
                </Grid>

                <Grid item xs={6}>
                  <NumberField
                    label="Preço unitário (PU)"
                    value={precoUnitario}
                    onChange={(value) => {
                      updatePrecoUnitario(value ?? 0);
                      updateField({ name: 'instrumentoPU', value });
                    }}
                    required
                    numberType="eightDecimals"
                    error={precoUnitarioTouched && (!precoUnitario || precoUnitario <= 0)}
                    errorMessage={'Preço unitário deve ser maior que zero'}
                  />
                </Grid>
              </Grid>
            </>
          )}

          {cadastroMovimentacao.tipoMovimentacao === 'COMPRA' && (
            <Box mt={3}>
              <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                  <AutoComplete
                    label="Custodiante (Contraparte)"
                    options={custodiantes}
                    getOptionLabel={(option: ParticipanteResponse) =>
                      `${option.razaoSocial} - ${addCpfCnpjMask(option.cnpj)}`
                    }
                    value={cadastroMovimentacao.contraparte.participante}
                    onChange={(value: ParticipanteResponse | null) => {
                      if (value) {
                        const selectedParticipante = custodiantes.find((p) => p.id === value.id);
                        if (selectedParticipante) {
                          dispatch(
                            updateCadastroMovimentacao({
                              ...cadastroMovimentacao,
                              contraparte: {
                                contaDeposito: null,
                                participante: selectedParticipante,
                                investidor: null,
                              },
                            })
                          );
                        }
                      }
                    }}
                    PaperComponent={({ children }) => (
                      <Paper style={{ width: '500px', height: '100%' }}>{children}</Paper>
                    )}
                    renderOption={(option: ParticipanteResponse) => (
                      <div style={{ width: '100%' }}>
                        <div style={{ display: 'flex' }}>
                          <Typography style={{ margin: 'auto 12px' }}>{addCpfCnpjMask(option.cnpj)}</Typography>
                        </div>
                        <div>
                          <Typography style={{ margin: 'auto 12px' }} variant="body2">
                            {option.razaoSocial}
                          </Typography>
                        </div>
                      </div>
                    )}
                    required
                  />
                </Grid>

                <Grid item xs={12} md={6}>
                  <TextField
                    label="Investidor (Contraparte)"
                    value={cadastroMovimentacao.contraparte.contaDeposito}
                    onChange={(value: string | null) => {
                      const sanitized = sanitizeAlphanumericCnpj(value ?? '');

                      let result = '';
                      if (sanitized.length <= 11 && /^\d+$/.test(sanitized)) {
                        result = addCpfCnpjMask(sanitized) || sanitized;
                      } else if (/^\d{12}$/.test(sanitized)) {
                        result = ContaDepositoMask(sanitized)!;
                      } else if (sanitized.length <= 14) {
                        result = addCpfCnpjMask(sanitized) || sanitized;
                      } else {
                        result = addCpfCnpjMask(sanitized.slice(0, 14));
                      }

                      const cleanValue = sanitizeAlphanumericCnpj(result);

                      if (/^\d{12}$/.test(cleanValue)) {
                        const isValid = validaContaDeposito(result);
                        setInvestidorContraparteError(isValid ? '' : 'Conta depósito inválida');
                      } else if (cleanValue.length === 14 || cleanValue.length === 11) {
                        const isValid = validaCpfCnpj(result);
                        setInvestidorContraparteError(isValid ? '' : 'CPF/CNPJ inválido');
                      } else if (cleanValue.length > 0) {
                        setInvestidorContraparteError('Formato inválido');
                      } else {
                        setInvestidorContraparteError('');
                      }

                      const updatedContraparte = { ...cadastroMovimentacao.contraparte, contaDeposito: result };
                      dispatch(
                        updateCadastroMovimentacao({ ...cadastroMovimentacao, contraparte: updatedContraparte })
                      );
                    }}
                    onBlur={() => {
                      const value = cadastroMovimentacao.contraparte.contaDeposito;
                      if (!value) {
                        setInvestidorContraparteError('');
                        return;
                      }

                      const cleanValue = sanitizeAlphanumericCnpj(value);

                      if (/^\d{12}$/.test(cleanValue)) {
                        const isValid = validaContaDeposito(value);
                        setInvestidorContraparteError(isValid ? '' : 'Conta depósito inválida');
                      } else if (cleanValue.length === 14 || cleanValue.length === 11) {
                        const isValid = validaCpfCnpj(value);
                        setInvestidorContraparteError(isValid ? '' : 'CPF/CNPJ inválido');
                      } else if (cleanValue.length > 0) {
                        setInvestidorContraparteError('Formato inválido');
                      }
                    }}
                    required
                    error={!!investidorContraparteError}
                    helperText={investidorContraparteError || 'Conta depósito ou CPF/CNPJ'}
                    errorMessage={investidorContraparteError}
                  />
                </Grid>

                <Grid item xs={12} md={6}>
                  <NumberField
                    label="Quantidade"
                    value={quantidade}
                    onChange={(value) => {
                      if (value === undefined || value === null) {
                        setQuantidade(0);
                        return;
                      }

                      const numericValue = typeof value === 'string' ? parseFloat(value) : value;

                      setQuantidade(numericValue);
                    }}
                    required
                    numberType="integer"
                  />
                </Grid>

                <Grid item xs={6}>
                  <NumberField
                    label="Preço unitário (PU)"
                    value={precoUnitario}
                    onChange={(value) => {
                      updatePrecoUnitario(value ?? 0);
                      updateField({ name: 'instrumentoPU', value });
                    }}
                    required
                    numberType="eightDecimals"
                    error={precoUnitarioTouched && (!precoUnitario || precoUnitario <= 0)}
                    errorMessage={'Preço unitário deve ser maior que zero'}
                  />
                </Grid>
              </Grid>
            </Box>
          )}

          <Box mt={3}>
            <Grid container>
              <Grid item xs={12} md={12}>
                <Dropdown
                  label="Modalidade Liquidação"
                  options={[
                    { value: 'BRUTA', description: 'Bruta' },
                    { value: 'DIRETA', description: 'Direta' },
                  ].filter((option) => option.value !== 'BRUTA' || instrumento?.tipoInstrumentoFinanceiro !== InstrumentoFinanceiro.CotasDeFundo)}
                  value={cadastroMovimentacao.modalidadeLiquidacao}
                  onChange={(value) => {
                    const typedValue = value as 'BRUTA' | 'DIRETA';
                    dispatch(updateField({ name: 'modalidadeLiquidacao', value: typedValue }));
                  }}
                  required
                />
              </Grid>

              {instrumento?.distribuicaoPublica && (
                <Grid item xs={12} md={12} style={{ marginTop: '25px' }}>
                  <DatePickerBusinessDay
                    label="Data de Agendamento"
                    keyValue="dataAgendamento"
                    minDate={moment(new Date())}
                    value={cadastroMovimentacao.dataAgendamento}
                    onChange={(value) => {
                      dispatch(updateField({ name: 'dataAgendamento', value }));
                    }}
                  />
                </Grid>
              )}
            </Grid>
          </Box>
        </Box>
      </Section>

      <Grid container spacing={3}>
        <Grid item xs={12} md={12}>
          <Divider />
        </Grid>
      </Grid>

      {/* Contraparte */}
      {cadastroMovimentacao.tipoMovimentacao === 'VENDA' && (
        <Section title="Contraparte" isFulfilled={() => true} defaultGrid={false}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <AutoComplete
                label="Custodiante (Contraparte)"
                options={custodiantes}
                getOptionLabel={(option: ParticipanteResponse) =>
                  `${option.razaoSocial} - ${addCpfCnpjMask(option.cnpj)}`
                }
                value={cadastroMovimentacao.contraparte.participante}
                onChange={(value: ParticipanteResponse | null) => {
                  if (value) {
                    const selectedParticipante = custodiantes.find((p) => p.id === value.id);
                    if (selectedParticipante) {
                      dispatch(
                        updateCadastroMovimentacao({
                          ...cadastroMovimentacao,
                          contraparte: {
                            contaDeposito: null,
                            participante: selectedParticipante,
                            investidor: null,
                          },
                        })
                      );
                    }
                  }
                }}
                PaperComponent={({ children }) => <Paper style={{ width: '500px', height: '100%' }}>{children}</Paper>}
                renderOption={(option: ParticipanteResponse) => (
                  <div style={{ width: '100%' }}>
                    <div style={{ display: 'flex' }}>
                      <Typography style={{ margin: 'auto 12px' }}>{addCpfCnpjMask(option.cnpj)}</Typography>
                    </div>
                    <div>
                      <Typography style={{ margin: 'auto 12px' }} variant="body2">
                        {option.razaoSocial}
                      </Typography>
                    </div>
                  </div>
                )}
                required
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <AutoComplete
                label={'Banco'}
                options={bancos ?? []}
                getOptionLabel={(option: BancoResponse | null) => {
                  if (!option) return '';
                  return `${option.code} - ${option.fullname}`;
                }}
                value={cadastroMovimentacao.bancoRecebedor || null}
                onChange={(value: BancoResponse | null) =>
                  dispatch(
                    updateCadastroMovimentacao({
                      ...cadastroMovimentacao,
                      bancoRecebedor: value,
                    })
                  )
                }
                filterOptions={
                  bancos
                    ? (_options: Array<BancoResponse>, state) => bancosFilter(state.inputValue.toLocaleLowerCase())
                    : undefined
                }
              />
            </Grid>
          </Grid>
          <Grid container spacing={3}>
            <Grid item xs={12} md={12}>
              <TextField
                label="Investidor (Contraparte)"
                value={cadastroMovimentacao.contraparte.contaDeposito}
                onChange={(value: string | null) => {
                  let result = value?.replace(/\D/g, '') ?? '';

                  if (result.length === 12) {
                    result = ContaDepositoMask(result)!;
                  } else if (result.length === 14 || result.length === 11) {
                    result = addCpfCnpjMask(result)!;
                  } else if (result.length > 14) {
                    result = addCpfCnpjMask(result.slice(0, 14));
                  }

                  const numericValue = result.replace(/\D/g, '');

                  if (numericValue.length === 12) {
                    const isValid = validaContaDeposito(result);
                    setInvestidorParteError(isValid ? '' : 'Conta depósito inválida');
                  } else if (numericValue.length === 14 || numericValue.length === 11) {
                    const isValid = validaCpfCnpj(result);
                    setInvestidorParteError(isValid ? '' : 'CPF/CNPJ inválido');
                  } else if (numericValue.length > 0) {
                    setInvestidorParteError('Formato inválido');
                  } else {
                    setInvestidorParteError('');
                  }

                  const updatedCadastroMovimentacao = {
                    ...cadastroMovimentacao,
                    contraparte: {
                      ...cadastroMovimentacao.contraparte,
                      contaDeposito: result,
                    },
                  };
                  dispatch(updateCadastroMovimentacao(updatedCadastroMovimentacao));
                }}
                onBlur={() => {
                  const value = cadastroMovimentacao.contraparte.contaDeposito;
                  if (!value) {
                    setInvestidorParteError('');
                    return;
                  }

                  const numericValue = value.replace(/\D/g, '');

                  if (numericValue.length === 12) {
                    const isValid = validaContaDeposito(value);
                    setInvestidorParteError(isValid ? '' : 'Conta depósito inválida');
                  } else if (numericValue.length === 14 || numericValue.length === 11) {
                    const isValid = validaCpfCnpj(value);
                    setInvestidorParteError(isValid ? '' : 'CPF/CNPJ inválido');
                  } else if (numericValue.length > 0) {
                    setInvestidorParteError('Formato inválido');
                  }
                }}
                helperText={investidorParteError || 'Conta depósito ou CPF/CNPJ'}
                required
                error={!!investidorParteError}
                errorMessage={investidorParteError}
              />
            </Grid>
          </Grid>
        </Section>
      )}

      {/* Contraparte */}
      {cadastroMovimentacao.tipoMovimentacao === 'COMPRA' && (
        <Section title="Parte" isFulfilled={() => true} defaultGrid={false}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={12}>
              <AutoComplete
                label="Investidor (Parte)"
                options={investidoresCustodianteOptions}
                getOptionLabel={(option: InvestidorResponse) =>
                  option ? `${option.razaoSocial} - ${addCpfCnpjMask(option.cpfCnpj)}` : ''
                }
                filterOptions={(options, state) => filterInvestidores(options, state.inputValue)}
                value={cadastroMovimentacao.parte.investidor}
                onChange={(value: InvestidorResponse | null) => {
                  if (value) {
                    const selectedInvestidor = investidoresCustodianteOptions.find((p) => p.id === value.id);

                    if (selectedInvestidor) {
                      dispatch(
                        updateCadastroMovimentacao({
                          ...cadastroMovimentacao,
                          parte: {
                            ...cadastroMovimentacao.parte,
                            investidor: selectedInvestidor,
                          },
                        })
                      );
                    }
                  } else {
                    dispatch(
                      updateCadastroMovimentacao({
                        ...cadastroMovimentacao,
                        parte: {
                          ...cadastroMovimentacao.parte,
                          investidor: null,
                        },
                      })
                    );
                  }
                }}
                PaperComponent={({ children }) => <Paper style={{ width: '500px', height: '100%' }}>{children}</Paper>}
                renderOption={(option: InvestidorResponse) => (
                  <div style={{ width: '100%' }}>
                    <Grid container>
                      <Grid item xs={4}>
                        <div>
                          <Typography style={{ margin: 'auto' }} variant="subtitle2">
                            {'CPF/CNPJ'}
                          </Typography>
                        </div>
                        <div>
                          <Typography style={{ margin: 'auto' }}>{addCpfCnpjMask(option.cpfCnpj)}</Typography>
                        </div>
                      </Grid>
                      <Grid item xs={4}>
                        <div>
                          <Typography style={{ margin: 'auto' }} variant="subtitle2">
                            {'Razão Social'}
                          </Typography>
                        </div>
                        <div>
                          <Typography style={{ margin: 'auto' }}>{option.razaoSocial}</Typography>
                        </div>
                      </Grid>
                      <Grid item xs={4}>
                        <div>
                          <Typography style={{ margin: 'auto' }} variant="subtitle2">
                            {'Conta depósito'}
                          </Typography>
                        </div>
                        <div>
                          <Typography style={{ margin: 'auto' }}>{option.contaDeposito}</Typography>
                        </div>
                      </Grid>
                    </Grid>
                  </div>
                )}
                required
              />
            </Grid>
          </Grid>
        </Section>
      )}

      {/* Dados bancários */}
      {cadastroMovimentacao.tipoMovimentacao === 'OFERTA_PRIMARIA' && (
        <>
          <Section title="Dados bancários do Custodiante" isFulfilled={() => true} defaultGrid={false}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={12}>
                <AutoComplete
                  label={'Banco'}
                  options={bancos ?? []}
                  getOptionLabel={(option: BancoResponse | null) => {
                    if (!option) return '';
                    return `${option.code} - ${option.fullname}`;
                  }}
                  value={cadastroMovimentacao.bancoPagador || null}
                  onChange={(value: BancoResponse | null) => {
                    if (value) {
                      dispatch(
                        updateCadastroMovimentacao({
                          ...cadastroMovimentacao,
                          bancoPagador: value,
                        })
                      );
                    }
                  }}
                  filterOptions={
                    bancos
                      ? (_options: Array<BancoResponse>, state) => bancosFilter(state.inputValue.toLocaleLowerCase())
                      : undefined
                  }
                />
              </Grid>
            </Grid>
            <Grid container spacing={3}>
              <Grid item xs={12} md={6}>
                <TextField
                  label="Conta bancária"
                  value={cadastroMovimentacao.parte.dadosBancarios?.conta}
                  onChange={(value: string | null) =>
                    dispatch(
                      updateCadastroMovimentacao({
                        ...cadastroMovimentacao,
                        parte: {
                          ...cadastroMovimentacao.parte,
                          dadosBancarios: {
                            ...cadastroMovimentacao.parte.dadosBancarios,
                            conta: value ?? '',
                            agencia: cadastroMovimentacao.parte.dadosBancarios?.agencia ?? null,
                          },
                        },
                      })
                    )
                  }
                />
              </Grid>

              <Grid item xs={12} md={6}>
                <TextField
                  label="Agência"
                  value={cadastroMovimentacao.parte.dadosBancarios?.agencia}
                  onChange={(value: string | null) =>
                    dispatch(
                      updateCadastroMovimentacao({
                        ...cadastroMovimentacao,
                        parte: {
                          ...cadastroMovimentacao.parte,
                          dadosBancarios: {
                            ...cadastroMovimentacao.parte.dadosBancarios,
                            agencia: value ?? '',
                            conta: cadastroMovimentacao.parte.dadosBancarios?.conta ?? null,
                          },
                        },
                      })
                    )
                  }
                />
              </Grid>
            </Grid>
          </Section>

          <Grid container spacing={3}>
            <Grid item xs={12} md={12}>
              <Divider />
            </Grid>
          </Grid>
        </>
      )}

      {/* Investidores */}
      {cadastroMovimentacao.tipoMovimentacao === 'OFERTA_PRIMARIA' && (
        <Grid container spacing={3} style={{ marginTop: '16px' }}>
          <Grid container item xs={12} md={12} alignItems="center" justifyContent="space-between">
            <Grid item>
              <Typography variant="h3">Investidores</Typography>
            </Grid>
            <Grid item>
              <Button
                variant="contained"
                size="small"
                color="primary"
                onClick={() =>
                  window.open(
                    'https://laqus-static-prod.s3.sa-east-1.amazonaws.com/solicitacoes/Modelo_Investidores_Movimentacao.xlsx',
                    '_blank'
                  )
                }
              >
                <Download fontSize="small" style={{ marginRight: '10px' }} />
                {'Baixar planilha Modelo'}
              </Button>
            </Grid>
          </Grid>

          <Grid item xs={12} md={12}>
            <div
              onClick={openFileDialog}
              onDragOver={onDragOver}
              onDragLeave={onDragLeave}
              onDrop={onDrop}
              style={{
                width: '100%',
                border: '1px dashed #D7D8D9',
                borderRadius: '8px',
                cursor: 'pointer',
                textAlign: 'center',
              }}
            >
              <MdSpace />
              <AttachFile fontSize="small" />
              <Typography color="textSecondary" variant="body2">
                {highlight ? 'Solte para carregar os arquivos' : `Arraste e solte ou SELECIONE OS DOCUMENTOS`}
              </Typography>
              <input
                ref={inputRef}
                type="file"
                accept={acceptedFileTypes.join(',')}
                multiple={false}
                style={{ display: 'none' }}
                onChange={onInputChange}
              />
              <MdSpace />
            </div>

            <AdicionarInvestidor
              attachments={anexosInvestidores}
              onAttachments={(anexo) => setAnexosInvestidores(anexo)}
              isFulfilled={() => true}
              investidoresXLSX={formattedData}
              ocultarDadosBancarios={true}
              delimitacaoCoordenador={delimitacaoCoordenador}
            />
          </Grid>
        </Grid>
      )}
      {delimitacaoErrorMessage && (
        <div
          style={{
            backgroundColor: '#f8d7da',
            color: '#721c24',
            padding: '15px',
            borderRadius: '4px',
            marginBottom: '20px',
            marginTop: '20px',
            textAlign: 'center',
            width: '100%',
            fontSize: '16px',
            fontWeight: 'bold',
            border: '2px solid #721c24',
            boxShadow: '0 0 10px rgba(0,0,0,0.2)',
          }}
        >
          <Typography variant="body1">
            <strong>Erro:</strong> {delimitacaoErrorMessage}
          </Typography>
        </div>
      )}

      <Grid container justify="center" direction="column" alignItems="center" spacing={2}>
        {cadastroMovimentacao.tipoMovimentacao === 'OFERTA_PRIMARIA' &&
          (exceedsDelimitacao || exceedsValorDelimitacao) && (
            <Grid item>
              <div
                style={{
                  backgroundColor: '#f8d7da',
                  color: '#721c24',
                  padding: '10px',
                  borderRadius: '4px',
                  marginBottom: '15px',
                  textAlign: 'center',
                  width: '100%',
                }}
              >
                <Typography variant="body2">
                  <strong>Erro:</strong>{' '}
                  {exceedsDelimitacao
                    ? 'A quantidade total de investimentos excede o limite de delimitação do coordenador.'
                    : 'O valor total (quantidade × PU) dos investidores excede o limite de delimitação do coordenador.'}
                  Ajuste as quantidades antes de prosseguir.
                </Typography>
              </div>
            </Grid>
          )}
        {cadastroMovimentacao.tipoMovimentacao === 'OFERTA_PRIMARIA' &&
          quantidadeDelimitacaoObj &&
          valorDelimitacaoObj &&
          !exceedsDelimitacao &&
          !exceedsValorDelimitacao && (
            <Grid item>
              <div
                style={{
                  backgroundColor: '#cce5ff',
                  color: '#004085',
                  padding: '10px',
                  borderRadius: '4px',
                  marginBottom: '15px',
                  textAlign: 'center',
                  width: '100%',
                }}
              >
                <Typography variant="body2">
                  Atenção: Existem limites de delimitação para quantidade e valor total (quantidade × PU). Certifique-se
                  de não exceder estes limites.
                </Typography>
              </div>
            </Grid>
          )}
        <Grid item>
          <Button
            variant="contained"
            color="primary"
            onClick={handleMovimentacaoSubmit}
            disabled={submitting || !isFormValid() || isLoading() || exceedsDelimitacao || exceedsValorDelimitacao}
          >
            {submitting ? 'Processando...' : 'Cadastrar Movimentação'}
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
};

export default NovoCadastroMovimentacao;
